// extracted by mini-css-extract-plugin
module.exports = {"options":"K1MW4s","label":"xQOiyy","labelText":"RIrqsK","checkbox":"iA05DQ"};